import { render, staticRenderFns } from "./robotSpreadOrder.vue?vue&type=template&id=56566dee&scoped=true&"
import script from "./robotSpreadOrder.vue?vue&type=script&lang=js&"
export * from "./robotSpreadOrder.vue?vue&type=script&lang=js&"
import style0 from "./robotSpreadOrder.vue?vue&type=style&index=0&id=56566dee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56566dee",
  null
  
)

export default component.exports